export const loginAPI = "/login";
export const registerAPI = "/register";
export const addEmailAPI = "/add-email";
export const verifyEmailAPI = "/verify-email";
export const resendPhoneVerificationCodeAPI = "/resend-phone-verifying-token";
export const verifyPhoneAPI = "/verify-phone-number";
export const resendVerificationCodeAPI = "/resend-email-verifying-token";
export const logoutAPI = "/logout";
export const forgotPasswordAPI = "/forgot-password";
export const resetPasswordAPI = "/reset-password";